<template>
  <el-dialog
    class="linkDialog"
    width="500px"
    title="设置"
    :visible.sync="visible"
    @close="dialogClose"
  >
    <el-form :model="survey.settings" label-width="150px">
      <el-form-item label="显示设置">
        <el-switch v-model="survey.settings.titleIndex"></el-switch>
        <span>显示问题编号</span>
      </el-form-item>
      <el-form-item label="回收设置">
        <el-switch v-model="survey.settings.ipLimit"></el-switch>
        <span>相同IP不能作答</span>
      </el-form-item>
      <p class="setting-subtitle">同一个WIFI算一个IP</p>
      <el-form-item label="设定发放和回收时间">
        <el-switch v-model="recyleDateStatus" @change="handleChangeRecyleDateStatus"></el-switch>
      </el-form-item>
      <div v-if="recyleDateStatus" style="margin-bottom: 20px;">
        <div>
          <el-checkbox v-model="survey.settings.recyleStartStatus">起始时间</el-checkbox>
          <recyleDate
            class="recyleDate"
            v-if="survey.settings.recyleStartStatus"
            :date="survey.settings.recyleStartTime"
            @change="handleSelectSTime"
          ></recyleDate>
        </div>
        <div style="margin-top:20px">
          <el-checkbox v-model="survey.settings.recyleStatus">结束时间</el-checkbox>
          <recyleDate
            class="recyleDate"
            v-if="survey.settings.recyleStatus"
            :date="survey.settings.recyleEndTime"
            @change="handleSelectETime"
          ></recyleDate>
        </div>
      </div>
      <!-- <el-form-item label="协作设置" v-if="survey.role==0">
        <el-switch v-model="survey.settings.cooperation"></el-switch>
      </el-form-item>
      <p class="setting-subtitle" v-if="survey.settings.cooperation">
        <a
          href="javascript:;"
          style="color:#FF552E;"
          @click="handleSwitchchangeStatus(true)"
        >编辑协作者>></a>
      </p>
      <el-form-item label="协作设置" v-if="survey.role!=0">
        <el-switch></el-switch>
      </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirmSettings">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { DOMAIN } from "../utils/api";
import { deepClone, uuid, MSG } from "../utils/utils";
import http from "../utils/http";
import { mapGetters, mapMutations, mapActions } from "vuex";
import recyleDate from "../components/recyleDate.vue";

export default {
  name: "settingsDialog",
  data() {
    return {
      interface: {
        saveSetting: `/survey/saveSetting`,
        getCooperationList: `/survey/cooperation/list`,
        updateCooperation: `/survey/cooperation/op`,
        searchUser: `/bsp/search`
      },
      visible: false,
      dateStatus: false
    };
  },
  props: ["dialogShow", "survey"],
  computed: {
    recyleDateStatus: {
      get: function() {
        return (
          this.dateStatus ||
          this.survey.settings.recyleStartStatus ||
          this.survey.settings.recyleStatus
        );
      },
      set: function(val) {
        this.dateStatus = val;
        if (!val) {
          this.survey.settings.recyleStartStatus = val;
          this.survey.settings.recyleStatus = val;
        }
      }
    }
  },
  watch: {
    shareSurvey: {
      deep: true,
      handler(val) {
        this.handleShare(val);
      }
    },
    dialogShow: {
      handler(val) {
        this.visible = val;
      }
    }
  },
  methods: {
    handleChangeRecyleDateStatus() {},

    handleSelectSTime(val) {
      let date = val.date ? val.date : "";
      let time = val.time ? val.time : "";
      this.$set(this.survey.settings, "recyleStartTime", date + " " + time);
    },
    handleSelectETime(val) {
      let date = val.date ? val.date : "";
      let time = val.time ? val.time : "";
      this.$set(this.survey.settings, "recyleEndTime", date + " " + time);
    },
    handleConfirmSettings() {
      if (
        this.survey.settings.recyleStatus &&
        !this.survey.settings.recyleEndTime
      ) {
        MSG.warning("回收时间必选");
        return;
      }
      let settings = deepClone(this.survey.settings);
      settings.recyleStatus = settings.recyleStatus == true ? 1 : 0;
      settings.recyleStartStatus = settings.recyleStartStatus == true ? 1 : 0;
      settings.surveyType = settings.surveyType == true ? 1 : 0;
      settings.oaUserLimit = settings.oaUserLimit == true ? 1 : 0;

      if (settings.recyleStartStatus && !settings.recyleStartTime) {
        MSG.warning("请设置开始时间");
        return;
      }
      if (settings.recyleStatus && !settings.recyleEndTime) {
        MSG.warning("请设置结束时间");
        return;
      }
      if (settings.recyleStartStatus && settings.recyleStartTime) {
        let startTime = settings.recyleStartTime.replace(/\-/g, "/");
        let _startTime = new Date(startTime).getTime();
        let now = new Date().getTime();
        if (_startTime <= now) {
          MSG.warning("开始时间不得早于当前时间");
          return;
        }
      }
      if (settings.recyleStatus && settings.recyleEndTime) {
        let endTime = settings.recyleEndTime.replace(/\-/g, "/");
        let _endTime = new Date(endTime).getTime();
        let now = new Date().getTime();
        if (_endTime <= now) {
          MSG.warning("结束时间不得早于当前时间");
          return;
        }
      }
      if (
        settings.recyleStartStatus &&
        settings.recyleStartTime &&
        settings.recyleStatus &&
        settings.recyleEndTime
      ) {
        let startTime = settings.recyleStartTime.replace(/\-/g, "/");
        let _startTime = new Date(startTime).getTime();
        let endTime = settings.recyleEndTime.replace(/\-/g, "/");
        let _endTime = new Date(endTime).getTime();
        if (_endTime - _startTime <= 0) {
          MSG.warning("结束时间不得早于开始时间");
          return;
        }
      }

      http
        .post(this.interface.saveSetting, {
          surveyId: this.survey.id,
          settingJson: JSON.stringify(settings)
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            MSG.success("保存成功");
            this.setSurveyType(settings.surveyType);
            if (!settings.recyleStatus && !settings.recyleStartStatus) {
              this.dateStatus = false;
            }
            this.$emit("update:dialogShow", false);
          } else {
            MSG.error(message);
          }
        });
    },
    handleSwitchchangeStatus(status) {
      if (status) {
        this.handleSettingCoopAccount();
      }
    },
    handleSettingCoopAccount() {
      this.settingDialogShow = false;
      this.cooperationDialogShow = true;
      http
        .get(this.interface.getCooperationList, {
          surveyId: this.SURVEY_ID
        })
        .then(response => {
          const { code, data, message } = response;
          if (code === 1) {
            this.cooperationList = data.filter(item => {
              if (item.role) {
                return item;
              }
            });
          } else {
            MSG.error(message);
          }
        });
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
    ...mapActions(["setSurveyType"])
  },
  components: {
    recyleDate
  }
};
</script>


<style lang="scss" scoped>
.linkDialog {
  .option-item {
    .option-text {
      display: inline-block;
      width: calc(100% - 400px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      float: left;
    }
    height: 35px;
    line-height: 35px;
    margin-bottom: 15px;
  }
  .link-item {
    float: left;
    margin-left: 30px;
  }
  .link-select {
    width: 100px;
    input {
      height: 30px;
    }
  }
  .dialog-footer {
    text-align: center;
  }
  .setting-subtitle {
    font-size: 12px;
    color: #ccc;
    position: relative;
    top: -25px;
  }
  .recyleDate {
    margin-top: -20px;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/settingsDialog.vue